import React, { Component } from 'react';
import { Col, Container, Row } from 'reactstrap';

import { A, R } from '../routes';

import API from '../API';
import { T } from '../traks';

class VerifyEmail extends Component {
	constructor(props) {
		super(props)
		this.state = {verified: false, error: false};
		const { a, b } = props;
		API.post("/z/finalize_email_verification", {a, b}, (response, status) => {
			if (status !== 200 || response !== true) {
				this.setState({error: true});
			} else {
				this.setState({verified: true});
			}
		});
	}

	render() {
		if (this.state.verified) {
			return (
				<Container className="pt-4 ad_pb-25">
					<Row className="ad_game_box p-4">
						<Col>
							<div className="d-table align-middle pb-1">
								<img alt="email-verified" src="/gfx/email-verified-0.svg" />
								<span className="ad_120_bold pl-3"><T>Your email has been verified!</T></span>
							</div>
							<div className="ad_profile_gray pb-4 font-small">(<T>You can safely close this window</T>)</div>
							<div className="pb-2"><T>You can find out more about us at our <A className="ad_blue_link" href="/about">about</A> page.</T></div>
							<div className="pb-2"><T>Curious about what markets we support? Have a look at our <A className="ad_blue_link" href="/explore">explore</A> section.</T></div>
							<div><T>We also have some <A className="ad_blue_link" href="/faq">frequently asked questions</A>.</T></div>
						</Col>
					</Row>
				</Container>
			)
		} else if (this.state.error) {
			return <div>ERROR</div>
		} else {
			return <div><T>Verifying email... please wait.</T></div>
		}
	}
}

export default (props) => {
	const args = R.get_args();
	return <VerifyEmail a={args.a} b={args.b}/>;
};



// WEBPACK FOOTER //
// ./src/p/VerifyEmail.js